import { type PaginationState as ReactTablePaginationState } from "@tanstack/react-table";

function toReactTablePagination(pagination: {
  pageIndex: number;
  pageSize: number;
}): ReactTablePaginationState {
  return {
    pageIndex: pagination.pageIndex,
    pageSize: pagination.pageSize,
  };
}

export { toReactTablePagination };
